<template>
  <div class="page-builder-context-menu">
    <sp-switch :checked="showGrid" label="Show Grid" @update-checked="setShowGrid"></sp-switch>
  </div>
</template>

<script setup>
import { usePageBuilderStore } from "../../store/page-builder";

const { showGrid } = usePageBuilderStore();

function setShowGrid({ detail }) {
  const [checked] = detail;
  showGrid.value = checked;
}
</script>

<style lang="scss">
:host {
  display: block;
}
</style>

<style lang="scss" scoped>
.page-builder-context-menu {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: white;
  border-top: 1px solid #ccc;
  width: 100%;
  z-index: 13;
  height: var(--sp-ref-spacing-24);
  padding-inline: var(--sp-ref-spacing-6);
}
</style>
